import { Outlet } from 'react-router-dom';

import { NavigationBar } from '../components/NavigationBar';

import { TicketFloatingButton } from '@/components/TicketFloatingButton';
import { useAuth } from '@/contexts/AuthContext';

export function DefaultLayout() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className="flex">
      <NavigationBar />

      <main className="w-full overflow-hidden px-6 lg:px-[60px]">
        <Outlet />
      </main>

      <TicketFloatingButton />
    </div>
  );
}
